<template>
  <v-row no-gutters class="justify-center popCon scrollYst_con">
    <v-col cols="12" class="mb-5">
      <span class="icon_pen">펜 굵기</span>
      <div class="penWth">
        <v-slider v-model="penWidth" @change="changePenWidth"
          :max="max"
          :min="min"
          hide-details
        >
          <template v-slot:append>
            <v-text-field
              v-model="penWidth"
              class="mt-0 pt-0"
              hide-details
              single-line
              readonly
            ></v-text-field>
          </template>
        </v-slider>
      </div>
    </v-col>
    <v-col cols="12">
    <div class="wrapper">
      <v-btn icon class="btnO_C00 delete" size="medium" type="info" @click="clear"><span class="icon">지우기</span></v-btn>
      <v-btn class="btnO_C01 reset1" size="medium" type="info" @click="undo"><span class="icon">되돌리기</span></v-btn>
      <canvas ref="canvas" id="signature-pad" class="signature-pad" width="400" height="200"></canvas>
    </div>
    </v-col>
    <!--<v-col cols="12">
      <v-checkbox v-if="visibleCheckBox" v-model="signToWatermark" label="계약서에 추가"></v-checkbox>
    </v-col>-->
  </v-row>
</template>

<script>
import SignaturePad from 'signature_pad/dist/signature_pad.min.js'

export default {
  name: 'signature',
  props: {
    visibleCheckBox: Boolean
  },
  data () {
    return {
      canvas: null,
      SignaturePad: {},
      penWidth: 3,
      min: 1,
      max: 10,
      signToWatermark: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.canvas = this.$refs.canvas
      const signaturePad = new SignaturePad(this.canvas)
      this.signaturePad = signaturePad
      this.resizeCanvas(this.canvas)
      window.onresize = this.resizeCanvas
    })
  },
  methods: {
    save () {
      if (this.signaturePad.isEmpty()) {
        this.$refs.confirm.open('alert', '전자 서명', '서명란에 서명을 해주세요.')
        return { data: null, signToWatermark: false }
      }

      var png = this.signaturePad.toDataURL('image/png')
      this.initSignaturePad()
      return { data: png, signToWatermark: this.signToWatermark }
    },
    clear () {
      this.signaturePad.clear()
    },
    undo () {
      var data = this.signaturePad.toData()
      if (data) {
        data.pop() // remove the last dot or line
        this.signaturePad.fromData(data)
      }
    },
    resizeCanvas () {
      const ratio = Math.max(window.devicePixelRatio || 1, 1)
      this.canvas.width = this.canvas.offsetWidth * ratio
      this.canvas.height = this.canvas.offsetHeight * ratio
      this.canvas.getContext('2d').scale(ratio, ratio)
    },
    changePenWidth () {
      // default width max : 2.5 min : 0.5     1.0:0.2 / 2.5:0.5 / 5:1 / 10:2
      this.signaturePad.maxWidth = this.penWidth
      this.signaturePad.minWidth = this.penWidth / 5
    },
    initSignaturePad () {
      this.penWidth = 2.5
      this.signaturePad.maxWidth = 2.5
      this.signaturePad.minWidth = 0.5
      this.signaturePad.penColor = 'rgb(0, 0, 0)'
      this.signaturePad.clear()
    }
  }
}
</script>
<style scoped>
.wrapper {
  position: relative;
  width: 400px;
  height: 200px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.signature-pad {
  width: 400px;
  height: 200px;
  border: 1px dotted gray;
  -ms-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  user-select: none;
  background-color: white;
}
</style>
